import DashboardInfo from "components/Agent/DashBordInfo";
import AgentBanner from "components/Banner/AgentBanner";
import 'assets/css/home.css';

const Dashboard = () => {
  return (
    <div className='agentDashboard-Container'>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100%',
        }}>
        <AgentBanner />
        <DashboardInfo />
      </div>
    </div>
  );
};

export default Dashboard;
